import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import { getOrgsEntity } from "../services/FormService";

function OrganizationEntitySelect({
  value,
  onChange,
  orgEntities,
  setOrgEntities,
}) {
  const [selectedValue, setSelectedValue] = useState("");
  useEffect(() => {
    getOrgsEntity().then((response) => {
      setOrgEntities(response.data);
    });
  }, []);

  return (
    <FormControl style={{ maxWidth: "15rem" }}>
      <FormHelperText style={{ margin: "0" }}>
        Choose organization entity
      </FormHelperText>
      <Select
        id="organization-entity-select"
        className="select-dropdown"
        value={value}
        defaultValue="Quicksand"
        sx={{
          "& .MuiInputBase-root": {
            maxHeight: 20,
          },
        }}
        onChange={onChange}
      >
        <MenuItem value="">Select</MenuItem>
        {orgEntities.length > 0 &&
          orgEntities.map((entity) => (
            <MenuItem key={entity._id} value={entity.slug}>
              {entity.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}

export default OrganizationEntitySelect;
